import { type ReactElement } from 'react';
import { NotificationSettingsControl } from '@/components/NotificationSettingsControl';
import { InAppAlertsAggregationControl } from '@/components/InAppAlertsAggregationControl';
import { Section } from '../Section';

export function PersonalNotificationsSubTab(): ReactElement {
  return (
    <div className="space-y-7">
      <Section
        title="In-App Notifications"
        description="Configure when you receive popup notifications for security alerts"
      >
        <NotificationSettingsControl />
      </Section>
      <Section
        title="In-App Alerts Aggregation"
        description="Control how often your in-app security alerts are combined into summary notifications by severity"
      >
        <InAppAlertsAggregationControl />
      </Section>
    </div>
  );
}
